import { FunctionComponent, useCallback } from 'react'
import {
  customEvent,
  useDxpPreviewParam,
  useWidgetContext,
} from '@dxp-module/common'
import { Login as LoginModule } from '@dxp-module/login'
import { MyAccountEvents } from '../../../LoginOrSignup/enum/MyAccountEvents'
import { labels, errors } from '../../../common/constants/LoginTranslations'
import ROUTES from '../../../common/enum/Routes'
import miniWidgetLoginStyles from './miniWidgetLogin.styles'

const MiniWidgetLogin: FunctionComponent = () => {
  const {
    configuration: { dealId, myAccountUrl },
  } = useWidgetContext()
  const styles = miniWidgetLoginStyles({})

  const handleLoginSuccess = useCallback(
    (accessToken?: string) => {
      customEvent.emit(MyAccountEvents.ON_LOGIN_SUCCESS, {
        dealId,
        accessToken,
      })
    },
    [dealId]
  )
  const previewSearchParam = useDxpPreviewParam()

  const handleForgotPassword = useCallback(
    () =>
      window.open(
        `${myAccountUrl || ''}${ROUTES.MYACCOUNT_FORGOT_PASSWORD}${
          previewSearchParam ? `?${previewSearchParam}` : ''
        }`
      ),
    [myAccountUrl, previewSearchParam]
  )
  return (
    <LoginModule
      labels={labels}
      errors={errors}
      onLoginSuccess={handleLoginSuccess}
      onForgotPassword={handleForgotPassword}
      actionButtonClasses={{ button: styles.button }}
      inputClasses={{
        input: styles.input,
        label: styles.inputLabel,
        iconButton: styles.passwordIconButton,
      }}
      classes={{
        subTitle: styles.subTitle,
        subTitleContainer: styles.subTitleContainer,
        subTitleSecondary: styles.subTitleSecondary,
        title: styles.title,
      }}
    />
  )
}

export default MiniWidgetLogin
